<template>
    <v-container>
      <v-row no-gutters>
        <div>
          <img :src="logoCompuesto" alt="Facultad de Química UNAM" />
        </div>
        <v-spacer></v-spacer>
        <div class="white--text departamento font-weight-bold">Sistema de Inscripción al Departamento de Idiomas</div>
      </v-row>
    </v-container>
  </template>
  
  <script>
  export default {
    name: "HeaderBase",
    data() {
      return {
        logoCompuesto: require("@/assets/logoCompuesto.png"),
      };
    },
  };
  </script>
  
  <style scoped>
  .departamento {
    max-width: 18rem;
    display: flex;
    justify-content: left;
    align-items: center;
    text-align: right;
    font-size: 22px;
  }
  </style>
  